import React, { useEffect } from 'react'
import HeroSection from '../../components/home_page/heroSection/HeroSection'
import Header from '../../components/home_page/header/Header'
import News_PressReleaseSection from '../../components/home_page/news&press_release/News_PressReleaseSection'
import ClientsAndTestimonials from '../../components/home_page/clients&testimonials/ClientsAndTestimonials'
import FAQsSection from '../../components/home_page/faqsSection/FAQsSection'
import PressReleaseSection from '../../components/home_page/pressRelease_section/PressReleaseSection'
import News from '../../components/home_page/news_section/News'
import ArticlesSection from '../../components/home_page/articles_section/ArticlesSection'
import { Box, styled } from '@mui/material'
import RecentDevelopmentsSection from '../../components/home_page/recentDevelopments_section/RecentDevelopmentsSection'
import CompanyProfileSection from '../../components/home_page/companyProfile_Section/CompanyProfileSection'

const MainBox = styled(Box)(({theme}) => ({
  width: '100%',
}));

function Home() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to top whenever pathname changes
  }, []);

  return (
    <MainBox>
      <Header/>
      <HeroSection/>
      <CompanyProfileSection/>
      <ArticlesSection/>
      <Box sx={{ width: '100%', pb: 2, pt: 6, display: 'flex', flexDirection: { xs: 'column', mdlg: 'row' }, justifyContent: { md: 'space-around', lg: 'center' }, alignItems: 'center', bgcolor: 'white' }} >
        <RecentDevelopmentsSection/>
        <News/>
      </Box>
      <FAQsSection/>
    </MainBox>
  )
}

export default Home